import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Importation from './views/Importation.vue';
import Login from './views/Login.vue';
import Signup from './views/Signup.vue';
import Document from './views/Document.vue';
import Detail from './views/Detail.vue';
import Contact from './views/contact.vue';
import Tracking from './views/tracking.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/Importation',
      name: 'Importation',
      component: Importation
    },
    {
      path: '/document',
      name: 'document',
      component: Document
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/tracking',
      name: 'tracking',
      component: Tracking
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    }
  ],
  mode: 'history'
});
